// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".process-info-unit[data-v-40ba1e0d]:not(:first-child){margin-top:.5rem}", "",{"version":3,"sources":["/Users/niwashouta/projects/kgi_sfa/app/javascript/erp_src/view/large_process/components/LargeProcessInfoUnit.vue"],"names":[],"mappings":"AAEC,sDACC,gBAAA","file":"LargeProcessInfoUnit.vue","sourcesContent":["\n.process-info-unit {\n\t&:not(:first-child) {\n\t\tmargin-top: 0.5rem;\n\t}\n}\n"]}]);
// Exports
module.exports = exports;
